<template>
  <div style="height:100%;width:100%;overflow-x:hidden;background-color: #F1F3F5" id="home">
    <div style="width:100%;height:80px;">
      <div  class="top" style="width:100%;height:80px;background: linear-gradient(to right, #E6F0FA, #2584FE);">
        <el-button icon="el-icon-s-fold" style="height: 78px;width: 78px;" @click="toggle()"></el-button>
        <a class="logo"><img src="@/assets/images/logo.png"  @click="goTo('')" /></a>
        <ul class="top_ul">
          <li class="nav_more">
                <a href="#" style="width:90px;" class="shezhi"><img src="@/assets/images/bg25.png" /></a>
                      <ul class="list_ol">
                        <li v-if="isAdmin"><a :href="$prefix + '#/largeScreen'">{{$t('homepage.bigDataBulletinBoard')}}</a></li>
<!--                        <li v-if="isAdmin"><a href="javascript:void(0)" @click="goToLargeScreen">{{$t('homepage.bigDataBulletinBoard')}}</a></li>-->
                        <li><a href="#" @click="goTo('Person')">{{$t('home.setting')}}</a></li>
                        <li><a href="#" @click="noticedialog">{{$t('home.notice')}}</a></li>
                        <li><a href="#" @click.prevent="logOut">{{$t('home.logOut')}}</a></li>
                      </ul>
              </li>
        </ul>
        <a href="#" @click="goTo('Person')" class="admin"><img src="@/assets/images/bg39.png" /><span style="color: #ffffff !important;">{{UserTitle}}，{{$t('homepage.welcome')}}</span></a>
        <el-switch
          v-model="currentLang"
          active-text="English"
          active-color="#474747"
          inactive-text="中文"
          inactive-color="#F25C01"
          active-value="en"
          inactive-value="zh"
          @change="changeLang">
        </el-switch>
      </div>
    </div>
    <div :class="$i18n.locale == 'en'?'hello englishText':'hello chineseText'" style="height:calc(100% - 80px);width: 100%;overflow:hidden">
      <div style="height:100%;position:fixed;left:0;width:200px;">
        <el-menu
          style="height:100%;text-align:left;width:100%;"
          default-active="homepage"
          class="el-menu-vertical-demo"
          background-color="#E6F0FA"
          text-color="#666666"
          active-text-color="#1478FE"

          @select="handleSelect"
          :collapse="isCollapse"
          :collapse-transition="true"
          :unique-opened="true"
          >

          <el-menu-item index="homepage" id="homepage" >
            <i class="el-icon-menu"></i>
            <span slot="title" class="custom-menu-item">{{$t('home.homePage')}}</span>
          </el-menu-item>
          <el-submenu index="3" v-if="Auth.equip || Auth.malfunction" >
            <template slot="title">
              <i class="el-icon-s-platform"></i>
              <span >{{$t('home.equipmentManagement')}}</span>
            </template>
              <el-menu-item index="equipmentmanagement" id="equipmentmanagement" v-if="Auth.equip">{{$t('home.equipmentList')}}</el-menu-item>
              <el-menu-item index="equipmentinspection" id="equipmentinspection" v-if="Auth.equipinspect">{{$t('home.equipmentQualityInspection')}}</el-menu-item>
              <el-menu-item index="usermanagement" id="usermanagement" v-if="Auth.usermanage">{{$t('home.assignEquipment')}}</el-menu-item>
              <el-menu-item index="malfunctionmanage" id="malfunctionmanage" v-if="Auth.malfunction">{{$t('home.faultList')}}</el-menu-item>
              <el-menu-item index="washRecords" id="washRecords" v-if="Auth.washRecords">{{$t('home.washrecords')}}</el-menu-item>
              <el-menu-item index="calibrationRecords" id="calibrationRecords" v-if="Auth.calibrationRecord">{{$t('home.calibrationRecords')}}</el-menu-item>
          </el-submenu>
          <!--<el-menu-item index="ordermanagement" id="ordermanagement" v-if="isAdmin || Auth.ordermanage">
            <i class="el-icon-s-order"></i>
            <span slot="title">{{$t('home.orderManagement')}}</span>
          </el-menu-item><-->
          <!--辅助运维模块-->
          <el-submenu index="assistMaintain" v-if="Auth.advertiseManagement || Auth.maintenanceRecord">
            <template slot="title">
              <i class="el-icon-user"></i>
              <span>{{$t('home.assistMaintenance')}}</span>
            </template>
            <el-menu-item v-if="Auth.advertiseManagement" index="advertiseManagement" id="advertiseManagement">广告管理</el-menu-item>
            <el-menu-item v-if="Auth.maintenanceRecord" index="maintenanceRecord" id="maintenanceRecord">运维记录</el-menu-item>
          </el-submenu>
          <el-submenu index="4" v-if="Auth.loggin || Auth.usermanage || Auth.pay">
            <template slot="title">
              <i class="el-icon-user"></i>
              <span>{{$t('home.accountManagement')}}</span>
            </template>
              <el-menu-item index="logginaccount" id="logginaccount" v-if="Auth.loggin">{{$t('home.loginAccount')}}</el-menu-item>
<!--              <el-menu-item index="WechatGroup">运维用户组</el-menu-item>-->
              <el-menu-item index="payconfig" id="payconfig" v-if="Auth.pay">{{$t('home.paymentConfiguration')}}</el-menu-item>
              <el-menu-item index="HuiFuAppConfig" id="HuiFuAppConfig" v-if="isAdmin">{{$t('homepage.huifuappconfiguration')}}</el-menu-item>
              <el-menu-item index="HuiFuMemberConfig" id="HuiFuMemberConfig" v-if="isAdmin">{{$t('homepage.huifuuserconfiguration')}}</el-menu-item>
              <el-menu-item index="HuiFuPaymentConfig" id="HuiFuPaymentConfig" v-if="isAdmin">{{$t('homepage.huifupayconfiguration')}}</el-menu-item>
          </el-submenu>
<!--          <el-submenu index="businessManagement" v-if="isAdmin">-->
<!--            <template slot="title">-->
<!--              <i class="el-icon-pie-chart"></i>-->
<!--              <span>企业管理</span>-->
<!--            </template>-->
<!--            <el-menu-item index="roleManagement" id="roleManagement" v-if="isAdmin">角色管理</el-menu-item>-->
<!--          </el-submenu>-->
          <el-submenu index="6" v-if="Auth.standardcon || Auth.userlevel">
            <template slot="title">
              <i class="el-icon-s-tools"></i>
              <span>{{$t('home.standardDataConfiguration')}}</span>
            </template>
            <el-menu-item index="equipmentGroup" id="equipmentGroup" v-if="Auth.equipmentGroup">设备分组维护</el-menu-item>
            <el-menu-item index="equiptypeconfig" id="equiptypeconfig" v-if="Auth.equiptypecon">{{$t('home.equipmentTypeConfiguration')}}</el-menu-item>
              <el-menu-item index="standardconfig" id="standardconfig" v-if="Auth.standardcon">{{$t('home.salesChannelConfiguration')}}</el-menu-item>
              <el-menu-item index="userlevelconfig" id="userlevelconfig" v-if="Auth.userlevel">{{$t('home.userLevelConfiguration')}}</el-menu-item>
          </el-submenu>
          <el-menu-item index="saledata" id="saledata" v-if="Auth.sale">
            <i class="el-icon-s-data"></i>
            <span slot="title">{{$t('home.salesDataStatistics')}}</span>
          </el-menu-item>
          <!--数据管理模块-->
          <el-submenu index="dataManagement" v-if="isAdmin || Auth.dataManagement">
            <template slot="title">
              <i class="el-icon-pie-chart"></i>
              <span>{{$t('home.dataManagement')}}</span>
            </template>
            <el-menu-item index="locationSalesStatistics" id="locationSalesStatistics" v-if="isAdmin || Auth.locationSalesStatistics">{{$t('home.locationSalesStatistics')}}</el-menu-item>
            <el-menu-item index="productSalesStatistics" id="productSalesStatistics" v-if="isAdmin || Auth.productSalesStatistics">{{$t('home.productSalesStatistics')}}</el-menu-item>
          </el-submenu>
          <el-menu-item index="remotecontrol" id="remotecontrol" v-if="Auth.remote">
            <i class="el-icon-link"></i>
            <span slot="title">{{$t('home.remoteControl')}}</span>
          </el-menu-item>
          <el-menu-item index="operatelog" id="operatelog" v-if="Auth.operate">
            <i class="el-icon-s-order"></i>
            <span slot="title">{{$t('operatelog.operationLog')}}</span>
          </el-menu-item>
          <el-menu-item index="trafficwarning" id="trafficwarning" v-if="Auth.traffic">
            <i class="el-icon-warning-outline"></i>
            <span slot="title">{{$t('home.flowEarlyWarning')}}</span>
          </el-menu-item>
          <el-menu-item index="myduty" id="myduty" v-if="Auth.myduty">
            <i class="el-icon-s-claim"></i>
            <span slot="title">{{$t('home.myTask')}}</span>
          </el-menu-item>
        </el-menu>
      </div>
      <!--查看奶茶配方已分配-->
      <!--内容区域-->
      <div :style="contentStyle">
        <el-tabs v-if=!this.IsHomepage  v-model="editableTabsValue" type="card" closable @tab-remove="removeTab" @tab-click="handleTabClick" style="margin:15px 10px -15px 0px">
          <el-tab-pane
            v-for="(item, index) in tabs"
            :key="index"
            :label="$i18n.locale =='zh'?item.title:item.englishTitle"
            :name="item.index"
            >
          </el-tab-pane>
        </el-tabs>
        <!--这里是路由加载进来的页面-->
        <router-view  style="height:100%;overflow:hidden;"/>
      </div>
    </div>
  </div>

</template>

<script>
import EquipmentManagement from '@/pages/equipmentmanagement/equipmentmanagement'
export default {
  name: 'home',
  data () {
    return {
      BoardInfoShowIs:0,
      BoardInfoShow:"",
      totalBoardCount:0,
      currentPage4:1,
      Boardtable: [],
      pageSize:10,
      pageIndex:1,
      noticetable: [],
      IotNoticeVisible: false,
      value: 0,
      timer: '',//计时器
      pwidth:0,//公告文本的宽度
      windowWidth:document.documentElement.clientWidth,// 设备屏幕的宽度
      IsHomepage:false,
      isCollapse:false,
      dateKey:new Date,
      saleList:[],
      saleRankList:[],
      UserTitle:"",
      contentStyle:{
        background:"#fff",
        height:"100%",
        position:"relative",
        transition:'all .5s',
        'margin-right':"3px",
        'margin-left':"210px"
      },
      selected:'homepage',
      tabs: [
      ],
      editableTabsValue: 'homepage',
      routerConfigs:[
        {index:"homepage",title:"首页",englishTitle:'homePage'},
        {index:"equipmentmanagement",title:"设备列表",englishTitle:'equipment list'},
        {index:"equipmentinspection",title:"设备质检",englishTitle:'equipment quality inspection'},
        {index:"malfunctionmanage",title:"故障列表",englishTitle:'fault list'},
        {index:"logginaccount",title:"登录账号",englishTitle:'login account'},
        {index:"usermanagement",title:"分配设备",englishTitle:'assign equipment'},
        {index:"payconfig",title:"收款配置",englishTitle:'payment configuration'},
        {index:"HuiFuAppConfig",title: "汇付应用配置",englishTitle: 'huifuapp configuration'},
        {index:"HuiFuPaymentConfig",title: "汇付收款配置",englishTitle: 'huifu configuration'},
        {index:"HuiFuMemberConfig",title: "汇付用户配置",englishTitle: 'huifu member configuration'},

        {index:"equipmentGroup",title:"设备分组维护",englishTitle:'equipment group maintenance'},
        {index:"equiptypeconfig",title:"设备类型配置",englishTitle:'assign equipment'},
        {index:"standardconfig",title:"销售渠道配置",englishTitle:'sales channel configuration'},
        {index:"userlevelconfig",title:"用户层级配置",englishTitle:'user level configuration'},
        {index:"saledata",title:"销售数据统计",englishTitle:'sales data statistics'},
        {index:"locationSalesStatistics",title:"点位销售统计",englishTitle:'location sales statistics'},
        {index:"productSalesStatistics",title:"商品销售统计",englishTitle:'product sales statistics'},
        {index:"remotecontrol",title:"远程控制",englishTitle:'remote control'},
        {index:"operatelog",title:"操作日志",englishTitle:'operation log'},
        {index:"trafficwarning",title:"流量预警",englishTitle:'flow early warning'},
        {index:"myduty",title:"我的任务",englishTitle:'my task'},
        {index:"personalcenter",title:"个人中心",englishTitle:'assign equipment'},
        {index:"Person",title:"个人信息",englishTitle:'person center'},

        {index:'washRecords',title:'清洗记录',englishTitle: 'washRecords'},
        {index:'calibrationRecords',title:'校准记录',englishTitle: 'CalibrationRecords'},
        {index:'video-maintain',title:'视频维护',englishTitle: 'videoMaintain'},

        {index:"advertiseManagement",title: "广告管理",englishTitle: 'advertise management'},
        {index:"maintenanceRecord",title:'运维记录',englishTitle:'maintenance record'},
        {index:"ordermanagement",title:"订单管理",englishTitle:'order management'},

        // 仿照重构计划
        {index:"roleManagement",title: "角色管理",englishTitle: 'role management'},

      ],
      menuTrees: new Object(),
      isAdmin:false,
      Auth:[{
        equip:false,
        equipinspect:false,
        malfunction:false,
        loggin:false,
        usermanage:false,
        pay:false,
        equiptypecon:false,
        standardcon:false,
        userlevel:false,
        sale:false,
        remote:false,
        promo:false,
        operate:false,
        traffic:false,
        myduty:false,
        promotions:false,
        rechargestrategy:false,

        dataManagement:false,
        locationSalesStatistics:false,
        productSalesStatistics:false,


        UpdateRecord:false,
        ordermanage:false,

        equipmentGroup:false
      }],
      currentLang:'zh',// 当前语言
      Isqek:false,
      isXl:false,// 是否是新蓝定制登录
    }
  },
  computed: {
    key () {
      return this.$route.path
    }
  },
  watch: {
    $route(to, from){
      // todo
      let tab = new Object();
      let arrayPath = to.path.split('/');
      let index = arrayPath[arrayPath.length-1];
      tab.index = index;
      tab.path = "/home/"+index;
      let routerConfig = this.routerConfigs.find(x=>x.index==index);
      if(routerConfig){
        tab.title = routerConfig.title;
        tab.englishTitle = routerConfig.englishTitle
      }
      if(this.tabs.filter(x=>x.index==index).length==0){
        this.tabs.push(tab);
      }
      this.editableTabsValue = index;
      //this.logFullRoute(to);
    }
  },
  mounted(){
      //console.log("被刷新",this.$account.data)
    //查看用户是否登录
    if(this.$account.data){
      this.isAdmin = this.$account.data.isAdmin;
      this.UserTitle = this.$account.data.accountName;
      let token = this.$cookies.get("token");
      let flag = sessionStorage.getItem("loginFlag")
      if(flag === "1"){
          this.Isqek = true
      }else if(flag === "2"){
          this.isXl = true
      }else{

      }
      if(!token){
        this.$router.push("/login");
      }else{
        //获取用户信息
        let that = this;
        let tokenStr = "Bearer "+token;
        this.$httpservice.get("api/account/currentaccount",{},{Authorization:tokenStr} ).then(
            function (data) {
                if(data.body.code=="200"){
                    that.$account.data = data.body.data;
                    that.UserTitle = data.body.data.accountName;
                    that.menuTrees = data.body.data.menuTrees;

                    that.menuTrees.forEach((item, index) => {
                        switch(item.code){
                          case 'equipmentmanagement':
                            that.Auth.equip = true;
                            break
                          case 'equipmentinspection':
                            that.Auth.equipinspect = true;
                            break
                          case 'malfunctionmanage':
                            that.Auth.malfunction = true;
                            break
                          case 'logginaccount':
                            that.Auth.loggin = true;
                            break
                          case 'usermanagement':
                            that.Auth.usermanage = true;
                            break
                          case 'payconfig':
                            that.Auth.pay = true;
                            break
                          case 'HuiFuAppConfig':
                            that.Auth.pay = true;
                            break
                          case 'HuiFuPaymentConfig':
                            that.Auth.pay = true;
                            break
                          case 'HuiFuMemberConfig':
                            that.Auth.pay = true;
                            break
                          case 'speeddelay':
                            that.Auth.speed = true;
                            break
                          case 'rawmaterial':
                            that.Auth.rawmater = true;
                            break
                          case 'equiptypeconfig':
                            that.Auth.equiptypecon = true;
                            break
                          case 'standardconfig':
                            that.Auth.standardcon = true;
                            break
                          case 'userlevelconfig':
                            that.Auth.userlevel = true;
                            break
                          case 'saledata':
                            that.Auth.sale = true;
                            break
                          case 'locationSalesStatistics':
                            that.Auth.locationSalesStatistics = true;
                            that.Auth.dataManagement = true;
                            break
                          case 'productSalesStatistics':
                            that.Auth.productSalesStatistics = true;
                            that.Auth.dataManagement = true;
                            break
                          case 'remotecontrol':
                            that.Auth.remote = true;
                            break
                          case 'operatelog':
                            that.Auth.operate = true;
                            break
                          case 'trafficwarning':
                            that.Auth.traffic = true;
                            break
                          case 'myduty':
                            that.Auth.myduty = true;
                            break
                          case 'promotions':
                            that.Auth.promotions = true;
                            break
                          case 'rechargestrategy':
                            that.Auth.rechargestrategy = true;
                            break
                          case 'washRecords':
                            that.Auth.washRecords = true;
                            break
                          case 'calibrationRecords':
                            that.Auth.calibrationRecord = true;
                            break
                          case 'ordermanagement':
                            that.Auth.ordermanage = true;
                            break
                          case 'advertiseManagement':
                            that.Auth.advertiseManagement = true
                            break
                          case 'maintenanceRecord':
                            that.Auth.maintenanceRecord = true
                            break
                          case 'equipmentGroup':
                            that.Auth.equipmentGroup = true
                            break
                        }
                    })
                    that.$forceUpdate();
                }else{
                    that.$message({
                        message: data.body.msg,
                        type: 'danger'
                    });
                  this.$router.push("/login");
                }
            },
            function (data) {
                let statusCode = data.status;
                that.$message({
                    message: that.$t('queryFailedStatusCode')+statusCode,
                    type: 'warning'
                });
              this.$router.push("/login");
            }
        );
      }
    }else{
      window.location.href="/";
    }

    this.initTabs();
    let temp = localStorage.getItem('languageSet')
    if(temp){
      this.currentLang = temp
    }else{
      this.currentLang = 'zh'
    }
  },
  methods:{
    handleSizeChange(e){
      this.pageSize=e;
      this.currentPage4 = 1
      this.loadMilkEquipList(1)
    },
    handleCurrentChange(e){
      this.currentPage4 = e
      this.loadMilkEquipList(e)
    },
    noticedialog(){
      this.IotNoticeVisible=true;
    },
    logFullRoute(route) {
      console.log('Full route information:', this.getFullRoute());
    },
    getFullRoute() {
      const fullUrl = window.location.href;
      const routeInfo = {
        fullUrl: fullUrl,
        path: this.$route.path,
        name: this.$route.name,
        params: this.$route.params,
        query: this.$route.query,
        hash: this.$route.hash,
        fullPath: this.$route.fullPath,
        matched: this.$route.matched
      };
      return routeInfo;
    },
    initTabs(){
      //初始化选项卡
      let arrayStr = window.location.href.split('/');
      let pageString = arrayStr[arrayStr.length-1];
      let routerConfig = this.routerConfigs.find(x=>x.index==pageString);
      if(routerConfig){
        let tab = { path: "/home/"+pageString, index: pageString, title: routerConfig.title,englishTitle:routerConfig.englishTitle};
        this.tabs.push(tab);
        this.editableTabsValue = pageString;
        if (tab.path.includes("homepage")) {
          this.IsHomepage=true;
        } else {
          this.IsHomepage=false;
        }
        this.$router.push("/home/"+pageString);
      }else{
        let tab = { path: "/home/homepage", index: "homepage", title: "首页",englishTitle:'home page' };
        this.tabs.push(tab);
        this.editableTabsValue = "homepage";
        if (tab.path.includes("homepage")) {
          this.IsHomepage=true;
        } else {
          this.IsHomepage=false;
        }
      }
    },
    handleTabClick(tab, event) {
      this.$router.push("/home/"+tab.name);
      if(tab.name=="homepage")
      {
        this.IsHomepage=true;
      }
      else
      {
        this.IsHomepage=false;
      }
    },
    removeTab(targetName){
      if(this.tabs.length==1){
        return;
      }

      let activeName = this.editableTabsValue;
      //如果关闭的是当前的选项卡
      if (activeName === targetName) {
        this.tabs.forEach((tab, index) => {
          if (tab.index === targetName) {
            //找到当前关闭的选项卡（即当前选项卡）的左边的或者右边的
            let nextTab = this.tabs[index + 1] || this.tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.index;
              this.$router.push("/home/"+nextTab.index);
            }

          }
        });
        if (activeName=="homepage")
        {
          this.IsHomepage=false;
        }
      }
      //选中
      this.editableTabsValue = activeName;
      //删除操作
      this.tabs = this.tabs.filter(tab => tab.index !== targetName);
    },

    handleSelect(index,indexPath){
      this.dateKey=new Date()

      this.$router.push("/home/"+index);
      if(index=="homepage")
      {
        this.IsHomepage=true;
      }
      else
      {
        this.IsHomepage=false;
      }
    },

    goTo(index){
      //直接跳转
      this.$router.push("/home/"+index);
    },
    toggle(){
      this.isCollapse = !this.isCollapse;
      if(this.isCollapse==true){
        this.contentStyle['margin-left'] = "74px";

      }else{
        this.contentStyle['margin-left'] = "200px";
      }
    },
    logOut(){
      this.$cookies.remove("token");
      this.$account.data = null;
      this.$router.push("/login");
    },
    changeLang(){
      // 看看当前是中文还是英文
      if(this.currentLang == 'en'){
        this.$i18n.locale = 'en'
      }else{
        this.$i18n.locale = 'zh'
      }
      localStorage.setItem('languageSet',this.$i18n.locale)
    },
    goToLargeScreen(){
      this.$router.push("/largeScreen")
    }

  },
  beforeDestroy() {
    //clearInterval(this.timer);
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dialog-footer{
  padding: 0px 15px 25px 25px;;
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 100px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 60%;
}
/*#box {
  width: 100%;
  height: 20px;

  position: relative;
}
.marquee-box  {
  position: relative;
  width: 100%;
  height: 100%;
  overflow:auto;
  background-color: #f8f8f8;
}
#pWidth{
  width: 100%;
  height: 20px;
  padding: 0;
  margin: 0;
  line-height: 20px;
  display: block;
  word-break: keep-all;
  white-space: nowrap;
  overflow:hidden;
  font-size:15px !important;
  background-color: #f8f8f8;
  color: #fc5454;
}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;height: 0;
}*/
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;color:#b4bed0;
  /*margin: 0 10px;*/width: 100%;
}
a {
  color: #42b983;
}
.top{ width:100%;height:80px;margin:0 auto; }
.top .logo{ display:inline-block;width:30%;margin:10px 0px 0px 10px;float:left;text-align:left; position:absolute;left:70px;}
.top .logo img{width:70%;}

.top .admin{ display:inline-block;float:right;line-height:80px;font-size:18px;color:#fff; overflow:hidden;}
.top .admin span{ display:inline-block;float:left;line-height:80px;font-size:18px;color:#fff;}

.top .admin img{width:40px;height:40px;margin:20px 10px 0px 0px; float:left;}
.top .top_ul{ float:right;margin:0px 20px 0px 0px; z-index:100001;padding:0;}
.top .top_ul li{list-style:none;display:inline;float:left;padding:0;}
.top .top_ul li .shezhi{display:block;float:left;padding:20px 10px 7px 10px;text-align:center;line-height:40px !important;font-family:"微软雅黑";font-size:18px;color:#fff;}
.top .top_ul li a:hover{}

.top .top_ul li .nav_specile{background:#fb8e00;color:#fff;}
.top .nav_more{}
.top .nav_more a:hover{color:#fff;}
.top .nav_more:hover .list_ol{display:block;}
.top .nav_more .list_ol{position:absolute;top:80px;width:110px;background:#35414f;display:none;padding:0px;border-top:none; z-index:100000; }
.top .nav_more .list_ol li a{display:block; text-align:center;width:110px;line-height:2.5;color:#b4bed0;font-size:15px;font-family:"微软雅黑";}
.top .nav_more .list_ol li a:hover{background:#35414f;border-bottom:none;color:#fff;line-height:2.5;}


.el-menu{width:16%;}

.el-menu--collapse{width:74px !important;}


    .el-button:focus, .el-button:hover {
    color: #b4bed0;
    border-color:none !important;
    }

    .el-button {
    display: inline-block;
    line-height:1.8;
    white-space: nowrap;
    cursor: pointer;
    background:none;
    color: #fff;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    -webkit-transition: .1s;
    transition: .1s;
    font-weight: 500;
    padding: 13px 20px; position:absolute;left:0;
    font-size:30px;
    border-radius:0px!important;
    border:none !important;
    outline-style:none;
    }

    .el-submenu .el-menu-item {
      min-width: 100px;
      background-color: #465f74;
    }

    .footer{
      position:absolute;
      right:0;
      bottom:0;
      left:0;
      height: 25px;
      /* background-color: #fff; */
      color: #777777;
    }
</style>
<style lang="less">
  #home{
    .el-switch{
      height: 80px;
      float: right;
      margin-right: 20px;
    }
    .el-switch__label.is-active{
      color: #fff;
    }
    .el-switch__label{
      color: #fff
    }
    .englishText{
      .el-menu-item{
        font-size: 12px!important;
      }
      .el-submenu__title{
        font-size: 12px!important;
      }
      .xssj_right1 span{
        font-size: 12px!important;
      }
      .sbph_row01{
        font-size: 12px!important;
      }
      .el-col-6{
        padding-left: 0!important;
        padding-right: 0!important;
      }
      .lsxs ul li span{
        font-size: 12px!important;
      }
      .spec-span{
        span{
          line-height: 20px!important;
        }
      }
    }
    .chineseText{
      .el-menu-item{
        font-size: 16px!important;
      }
      .el-submenu__title{
        font-size: 16px!important;
      }
      .xssj_right1 span{
        font-size: 16px!important;
      }
      .spec-span{
        span{
          line-height: 40px!important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home.vue